import type { Resource } from '../../';
export const country_countries_FR: Resource = {"default":"France"};
